export const SET_ACTIVE_SHOP = 'SET_ACTIVE_SHOP';